module.exports = __webpack_public_path__ + "img/sister.3f089c7d.png";